// CRA service worker registration — force-activate updates on every deploy (Android + iOS PWA).

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

const UPDATE_CHECK_MS = 60_000;

function swUrlForEnv() {
  if (process.env.NODE_ENV === 'production') {
    return `${process.env.PUBLIC_URL || ''}/service-worker.js`;
  }
  return `${process.env.PUBLIC_URL || ''}/sw.js`;
}

function askSkipWaiting(worker) {
  if (!worker) return;
  try {
    worker.postMessage({ type: 'SKIP_WAITING' });
  } catch {
    /* ignore */
  }
}

export function register(config) {
  if (!('serviceWorker' in navigator)) return;

  const shouldRegisterProd = process.env.NODE_ENV === 'production';
  const shouldRegisterDev =
    process.env.NODE_ENV !== 'production' &&
    (process.env.REACT_APP_ENABLE_SW === 'true' || isLocalhost);

  if (!shouldRegisterProd && !shouldRegisterDev) return;

  const swUrl = swUrlForEnv();

  // When a new SW takes control after deploy, reload once so JS/CSS/HTML match.
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    if (shouldRegisterProd && isLocalhost) {
      checkValidServiceWorker(swUrl, config);
      return;
    }
    registerValidSW(swUrl, config);
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('Service worker registered:', swUrl);

      if (config && config.onSuccess) {
        config.onSuccess(registration);
      }

      // If an update is already waiting (previous visit), activate it now.
      if (registration.waiting) {
        askSkipWaiting(registration.waiting);
      }

      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state !== 'installed') return;

          if (navigator.serviceWorker.controller) {
            // New version after deploy — activate immediately → controllerchange → reload
            console.log('New Prasaar build found — activating and refreshing…');
            askSkipWaiting(installingWorker);
            if (config && config.onUpdate) {
              config.onUpdate(registration);
            }
          } else if (config && config.onSuccess) {
            console.log('Content is cached for offline use.');
            config.onSuccess(registration);
          }
        });
      });

      // Periodically look for a new deploy while the app stays open.
      const checkUpdate = () => {
        registration.update().catch(() => undefined);
      };
      window.setInterval(checkUpdate, UPDATE_CHECK_MS);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkUpdate();
      });
      window.addEventListener('online', checkUpdate);
      // One early check shortly after load (covers fast Netlify deploys).
      window.setTimeout(checkUpdate, 5_000);
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.',
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
